import React from 'react';

import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

export const CalendarPickerProvider = ({ children }: { children: React.ReactNode }) => {
  return <MuiPickersUtilsProvider utils={MomentUtils}>{children}</MuiPickersUtilsProvider>;
};
